module.exports = __webpack_public_path__ + "assets/profile_blue.a2bae590.svg";